
import React from 'react';
import './CalendarViewSwitcher.css';

export type CalendarViewType = 'day' | 'week' | 'month' | 'year';

interface CalendarViewSwitcherProps {
    currentView: CalendarViewType;
    onViewChange: (view: CalendarViewType) => void;
    baseDate: Date;
    onDateChange: (date: Date) => void;
    translate: (key: string) => string;
}

export const CalendarViewSwitcher: React.FC<CalendarViewSwitcherProps> = ({
    currentView,
    onViewChange,
    baseDate,
    onDateChange,
    translate
}) => {
    const goToPrevious = () => {
        const newDate = new Date(baseDate);
        switch (currentView) {
            case 'day':
                newDate.setUTCDate(newDate.getUTCDate() - 1);
                break;
            case 'week':
                newDate.setUTCDate(newDate.getUTCDate() - 7);
                break;
            case 'month':
                const prevMonth = newDate.getUTCMonth() - 1;
                if (prevMonth === -1) {
                    newDate.setUTCMonth(11);
                    newDate.setUTCFullYear(newDate.getUTCFullYear() - 1);
                } else {
                    newDate.setUTCMonth(prevMonth);
                }
                break;
            case 'year':
                newDate.setUTCFullYear(newDate.getUTCFullYear() - 1);
                break;
        }
        onDateChange(newDate);
    };

    const goToNext = () => {
        const newDate = new Date(baseDate);
        switch (currentView) {
            case 'day':
                newDate.setUTCDate(newDate.getUTCDate() + 1);
                break;
            case 'week':
                newDate.setUTCDate(newDate.getUTCDate() + 7);
                break;
            case 'month':
                const nextMonth = newDate.getUTCMonth() + 1;
                if (nextMonth === 12) {
                    newDate.setUTCMonth(0);
                    newDate.setUTCFullYear(newDate.getUTCFullYear() + 1);
                } else {
                    newDate.setUTCMonth(nextMonth);
                }
                break;
            case 'year':
                newDate.setUTCFullYear(newDate.getUTCFullYear() + 1);
                break;
        }
        onDateChange(newDate);
    };

    const goToToday = () => {
        onDateChange(new Date());
    };

    return (
        <div className="calendarViewSwitcher">
            <div className="calendarViewSwitcher_navigation">
                <button className="calendarViewSwitcher_nav_button" onClick={goToPrevious}>
                    ←
                </button>
                <button className="calendarViewSwitcher_today_button" onClick={goToToday}>
                    {translate('calendar_today')}
                </button>
                <button className="calendarViewSwitcher_nav_button" onClick={goToNext}>
                    →
                </button>
            </div>
            
            <div className="calendarViewSwitcher_views">
                {(['day', 'week', 'month', 'year'] as CalendarViewType[]).map(view => (
                    <button
                        key={view}
                        className={`calendarViewSwitcher_view_button ${currentView === view ? 'active' : ''}`}
                        onClick={() => onViewChange(view)}
                    >
                        {translate(`calendar_${view}`)}
                    </button>
                ))}
            </div>
        </div>
    );
};
